export default [
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user/user.vue'),
    meta: { pageName: 'Mine-refused' }
  },
  {
    path: '/customerService',
    name: 'CustomerService',
    component: () => import('@/views/user/customerService.vue'),
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/user/setting.vue'),
    meta: { pageName: 'Settings' }
  },
  {
    path: '/bankCard',
    name: 'BankCard',
    component: () => import('@/views/user/bankCard.vue'),
    meta: { pageName: 'Bank' }
  },
  {
    path: '/changeCard',
    name: 'ChangeCard',
    component: () => import('@/views/user/changeCard.vue'),
    meta: { pageName: 'Bank_Change' }
  },
  {
    path: '/changeCardLiving',
    name: 'ChangeCardLiving',
    component: () => import('@/views/user/changeCardLiving.vue'),
    meta: { pageName: 'Bank_Liveness' }
  }
]
